@if (choosefluad | async; as item) {
  <div class="product_common-box fluad-commonbox">
    <div class="container">
        <div class="product_common-box-container ">
            <div class="product_common-box-content col-md-6 col-xs-12 ">
                <div class="wrapper_container">
                    <div class="product_common-boxHeader" [innerHTML]="item.headLine"></div>
                    <div class="product_common-boxSubHeader" [innerHTML]="item.name"></div>
                    <!-- <div class="product_common-box_subHeader_fluad d-none" [innerHTML]="item.textContent"></div> -->
                    <a [routerLink]="item.linkUrl" class="product_box1-button">{{"statictext.orderNow" | cxTranslate}}
                        <img alt="Next screen" src="../../../app/../assets/images/arrow-right.svg">
                        <!-- <img alt="Next screen" class="product_box1-button_arrow d-none" src="../../../app/../assets/images/arrow-right-white.svg"> -->
                    </a>
                    <div class="product_box1-disclaimer_Fluad d-none" [innerHTML]="item.bottomContent"></div>
                </div>

            </div>
            <div class="panel_body-bottomDivider"></div>

            <div class="product_common-box-Image1 col-md-6 col-xs-12 ">
                    <div class="simple-banner banner__component--responsive" *ngIf="item?.media">
                            <div class="product_common-box-Image1-subHeader" [innerHTML]="item.textContent">
                            </div>
                        <div  class=" product_common-box-Image1_Img ">
                            <img class="js-responsive-image1 box img-fluid " [attr.alt]="item.media?.altText" [attr.title]="item.media?.altText" [src]="getImage(item.media)">
                        </div>

                    </div>
                    <div class="product_box1-disclaimer_FlucelVax " [innerHTML]="item.bottomContent"></div>
            </div>
            <div class="product_box1-disclaimer_Fluad1 d-none" [innerHTML]="item.bottomContent"></div>
        </div>
            <div class="clearboth"></div>

    </div>
  </div>
}


